<template>
	<div>
		<div class="row">
			<div class="col-md-12 mb-2">
				<h4>Kliring VA Pangkalan LPG</h4>
			</div>
			<div class="col-md-12">
				<el-card shadow="never" class="box-card col-md-12 mb-4" :body-style="{ paddingLeft: '8px', paddingRight: '8px', paddingTop: '8px'  }">
					<div slot="header" class="clearfix" v-if="false">
						<span><strong>Kliring VA Pangkalan LPG</strong></span>
					</div>
					<div>
						<div class="mb-3" style="margin-top:0px;">
							<el-tabs v-model="tabIndex" @tab-click="handleTabClick">
								<el-tab-pane :label="item.label" :name="item.index" v-for="(item, index) in tabList" :key="item.name + '_' + index" >
									<BrimolaClearing :tabIndex="item.index" :tabName="item.name" :tabLabel="item.label"/>
								</el-tab-pane>

								<el-tab-pane :label="item.label" :name="item.index" v-for="(item, index) in tabListFinanceReport" :key="item.name + '_' + index" >
									<FinanceReportTab :tabIndex="item.index" :tabName="item.name" :tabLabel="item.label"/>
								</el-tab-pane>
							</el-tabs>
						</div>
					</div>
				</el-card>
			</div>
		</div>
	</div>
</template>
<script>

import LPG from '@/components/page/LPG.js'
import BrimolaClearing from '@/views/pages/BrimolaClearing.vue'
import FinanceReportTab from '@/views/pages/FinanceReport/FinanceReportTab.vue'

export default
{
	extends: LPG,
	components: {
		BrimolaClearing,
		FinanceReportTab,
	},

	data(){
		return {
			tabIndex: this.$route.query.tab ? this.$route.query.tab : '0',
			tabList:[
				{label:'Brimola', name: 'Brimola', index: '0' },
			],

			tabListFinanceReport:[
				//{label:'Cash Deposit Clearing', name: 'clearingcash', index: '20' },
				{label:'Non Brimola', name: 'clearingvalpg', index: '21' },
			],
		}
	},
	watch:
	{
		//area() { this.resumePilihan() },
		//status(){ this.resumePilihan() },
	},
    mounted()
    {
        this.$emit('childrenRoute');
    },
    methods:{
		handleTabClick() {
			/*
            this.tab.index = tabIndex
            this.tab.name = tabName
            this.tab.label = tabLabel
			*/
        },

    }
}
</script>
<style>

.fade-enter-active, .fade-leave-active {
  opacity: 1;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}


</style>
